<template>
  <v-container fluid class="add-role-page">
    <div class="pa-2 fill-height d-flex flex-column justify-start align-start">
      <v-row
        v-if="loading"
        no-gutters
        align="center"
        justify="center"
        class="fill-width"
      >
        <v-progress-circular
          :size="60"
          :width="5"
          color="primary"
          indeterminate
        />
      </v-row>
      <div v-else class="fill-width fill-height">
        <v-form
          @submit.prevent="createNewRole"
          class="create-new-role fill-height d-flex justify-space-between align-center align-content-start flex-wrap"
          ref="roleVerification"
        >
          <div
            class="d-flex justify-space-between align-center fill-width align-center mb-3"
          >
            <v-text-field
              v-model="roleName"
              :rules="roleRules"
              required
              :label="
                $t(
                  'panel.adminManagement.rolesPage.addRolePage.createNewRoleLabel'
                )
              "
              hide-details="auto"
              outlined
              class="theme-custom-input input-search input-role-name"
              autofocus
            />
            <v-btn
              color="primary"
              depressed
              :loading="loading"
              class="py-6"
              type="submit"
              >{{
                $t(
                  "panel.adminManagement.rolesPage.addRolePage.createNewRoleBtn"
                )
              }}</v-btn
            >
          </div>
          <v-row
            no-gutters
            align="center"
            justify="start"
            align-content="start"
            class="checkBoxes fill-width overflow-auto"
          >
            <v-col
              v-for="(action, index) in allActions"
              :key="index"
              sm="6"
              md="4"
              lg="3"
              class="py-0"
            >
              <div>
                <v-checkbox
                  v-model="action.selected"
                  :label="action.name"
                  dense
                  hide-details
                  class="checkbox pa-2 text-truncate mt-2"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { userInfoService } from "@/services";

export default {
  name: "add-role",
  data() {
    return {
      loading: false,
      allActions: [],
      roleName: "",
      roleRules: [
        v =>
          !!v ||
          this.$t(
            "panel.adminManagement.rolesPage.addRolePage.notEmptyRoleInput"
          )
      ]
    };
  },
  mounted() {
    this.getAllActions();
  },
  methods: {
    createNewRole() {
      if (!this.$refs.roleVerification.validate()) {
        return;
      }
      this.loading = true;
      let actionIds = [];
      this.allActions.map(item => {
        if (item.selected) {
          actionIds.push(item.id);
        }
      });
      userInfoService
        .createNewRole({ actionIds, roleTitle: this.roleName })
        .then(() => {
          this.$toast.success(
            this.$t(
              "panel.adminManagement.rolesPage.addRolePage.successMsgToast"
            )
          );
          this.$router.replace({ name: "roles" });
          // this.roleName = "";
          // this.getAllActions();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAllActions() {
      this.loading = true;
      userInfoService
        .getAllActions()
        .then(response => {
          this.allActions = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
@import "Add";
</style>
